import * as React from "react";
const SvgFastforwardClock = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24" }, props),
    React.createElement("g", { stroke: "currentColor", strokeWidth: 2 },
        React.createElement("path", { d: "M23 12A11 11 0 1 1 12 1c6 0 8.5 4.25 11 7" }),
        React.createElement("path", { d: "M23 4v4h-4M12 5v7h5" }))));
export default SvgFastforwardClock;
